const Arrow = (props) => (
  <svg
    width={77}
    height={89}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="arrow"
      d="M71.195 9.9v68.843l-59.62-34.422L71.195 9.9Z"
      stroke="#223843"
      strokeWidth={11}
    />
  </svg>
);

export default Arrow;
